export function numberToFixed(value: unknown): string {
  const num = Number(value)
  return num.toFixed(2)
}
